/**
 * @file Infoboxes support for Bing Maps AJAX Control 7.0
 * @see http://msdn.microsoft.com/en-us/library/gg427610.aspx
 * Requires jQuery 1.4.2+
 */

/*********************************************************************************************/

// Minimum CSS required to support infoboxes
$('head').append('<style>.VE_Pushpin_Popup{position: absolute; z-index: 1000; display: none;}</style>');


/**
 * Use this function to create Pushpins until it can use collection events.
 */
Microsoft.Maps.Map.prototype.AddInfobox = function(location, options){
   options._infobox = $('<div class="VE_Pushpin_Popup"></div>');

   var pin = new Microsoft.Maps.Pushpin(location, options);
   this.entities._tryLocationToPixel = this.tryLocationToPixel;
   this.entities.push(pin);

   if (!this.customInfoboxEntities) {
      this.customInfoboxEntities = [];
   }

   this.customInfoboxEntities.push(pin);

   var root = $( this.getRootElement() );
   root.append(pin._infobox);

   this._entityAdded({entity: pin, collection: this.entities}); // TODELETE: simulates the "entityAdded" event

   return pin;
}

Microsoft.Maps.Map.prototype.ClearInfoboxes = function() {
   var self = this;

   if (this.customInfoboxEntities) {
      $.each(this.customInfoboxEntities, function(i, pin) {
         pin._infobox.remove();
         self.entities.remove(pin);
      });
      self.customInfoboxEntities = [];
   }
};


/*********************************************************************************************/

Microsoft.Maps.Pushpin.prototype.ShowInfoBox = function(){
   var self = this,
      pos = self.tryLocationToPixel(
         self._location,
         Microsoft.Maps.PixelReference.control
      );

   if (pos) {
      var x = Math.floor(pos.x),
         y = Math.floor(pos.y),
         halfHeight = Math.floor(self._infobox.height() / 2),
         halfWidth = Math.floor(self._infobox.width() / 2),
         adjustedX = x - halfWidth,
         adjustedY = y - halfHeight;

      if ($.browser.msie  && parseInt($.browser.version, 10) === 7) {
         // Compensate for bug in IE7
         //adjustedX += 110;
      }

      self._infobox
         .css({
            position: 'absolute',
            left: adjustedX,
            top: adjustedY
         }).show();

      /*
       this._infobox.find(".areaName").html(
       "(" + adjustedX.toString() + ", " + adjustedY.toString() + ") " + x.toString() + "," + y.toString() + " [" + halfWidth.toString() + "," + halfHeight.toString() + "]"
       ).css({
       fontSize: "12px"
       });
       */

      //.fadeIn('fast'); //short transition
   } else {
      this._infobox.hide();
   }

   this._infoboxShown = true;
};

/*********************************************************************************************/

Microsoft.Maps.Pushpin.prototype._infoboxShown = false;

Microsoft.Maps.Pushpin.prototype._infoboxToggle = function(e){
   e.target.ToggleInfoBox();
};

Microsoft.Maps.Pushpin.prototype._infoboxShow = function(e){
   e.target.ShowInfoBox();
};

/*********************************************************************************************/

/**
 * Called when an entity is added to the map.
 */
Microsoft.Maps.Map.prototype._entityAdded = function(e){
   var entity = e.entity;
   if (entity._infobox){
      entity.tryLocationToPixel = e.collection._tryLocationToPixel;
   }
};

/**
 * Called when an entity is removed from the map.
 */
Microsoft.Maps.Map.prototype._entityRemoved = function(e){
   var entity = e.target;
   if (entity._infobox){
      entity.tryLocationToPixel = null;
      entity._infobox.remove();
   }
};

/*********************************************************************************************/

/**
 * Generates contents of the infobox and copy the extended options to the Pushpin instance (also called by the constructor).
 * NPO: if some options are missing, should it overwrite as NULL or leave the value as-is ? For now, it overwrites.
 */
Microsoft.Maps.Pushpin.prototype._setOptions = Microsoft.Maps.Pushpin.prototype.setOptions;
Microsoft.Maps.Pushpin.prototype.setOptions = function(options){
   // Pushpin options
   this._setOptions(options);

   // Infobox options: overwrites as NULL properties that are not provided
   if (options.sticky) this.sticky = options.sticky;
   if (options.title) this.title = options.title;
   if (options.description) this.description = options.description;
   if (options._infobox) this._infobox = options._infobox;

   // Infobox contents
   if (!options.infobox){
      options.infobox = $('<div class="Title">' + this.title + '</div><div class="Description">' + this.description + '</div>');
   } else if (options.infobox && this.infobox && (options.infobox != this.infobox)){
      this._infobox.remove( this.infobox );
   }

   // Add-replace the contents inside the infobox wrapper of this specific pin
   this.infobox = options.infobox;

   if (this._infobox) {
      this._infobox.append( this.infobox );
   }
};

/*********************************************************************************************/

/**
 * Extended "Map" constructor to listen to collection changes and map movements.
 */
window.Ve7Infobox = function(map) {
   // Entities collection events
   Microsoft.Maps.Events.addHandler(map.entities, 'entityadded', map._entityAdded);
   Microsoft.Maps.Events.addHandler(map.entities, 'entityremoved', map._entityRemoved);

   // Map movement (closes non-sticky infoboxes)
   Microsoft.Maps.Events.addHandler(map, 'viewchange', function() {
      var entities = map.customInfoboxEntities;
      if (!entities) return;
      var l = entities.length;
      for (var i = 0; i < l; i++){
         var entity = entities[i];
         entity.ShowInfoBox();
      }
   });
};

/*********************************************************************************************/
